import { buildProfileGuestEmail } from '../../utils/profileManager';

/** Auth/magic-link/OTP session email — profile email or platform-aware guest fallback. */
export function resolveAuthSessionEmailFromProfile(profile: {
  email?: string | null;
  phone?: string | null;
}): string | null {
  const trimmed = profile.email?.trim();
  if (trimmed) return trimmed;
  if (!profile.phone?.trim()) return null;
  return buildProfileGuestEmail(profile.phone);
}
